<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader @click="involvedModal = !involvedModal">
        Actions
        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize">
              <CIcon :name="`cil-chevron-${involvedModal ? 'bottom' : 'top'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="involvedModal" :duration="400">
        <CCardBody>
          <div class="col-sm-12 text-center float-left pb-2" v-if="$store.state.user.user_type === 'csr' || $store.state.user.user_type === 'admin' && 'pdf.csr_assigned_id' != null">
            <h5 style="width:100%;float:left;text-align:center;font-size:12px;">Rep: {{ form ? form.user.name : 'N/A' }}</h5>

            <select class="form-control" v-model="pdf.csr_assigned_id" style="margin-left:auto;margin-right:auto;">
              <option value="null">CSRs</option>
              <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
            </select>
            <CButton size="sm" style="width:100%;float:left;margin-top:10px;" color="success" @click="changeCSR()">Change CSR</CButton>

            <spacer />
          </div>
            <div class="col-sm-12 text-center float-left pb-2" v-if="$store.state.user.user_type !== 'rep' && pdf.as400_status !== 'Canceled' && pdf.as400_status !== 'Voided' && pdf.as400_status !== 'Waiting On Customer'">
            <h5 style="width:100%;float:left;text-align: center;font-size:12px;">CSR Folder</h5>
            <select class="form-control" v-model="pdf.csr_status" @change="changeCsrStatus()" style="margin-left:auto;margin-right:auto;">
              <option value="null">Select Folder</option>
              <!-- <option value="Components On Order">Components On Order</option> -->
              <option value="Good To Go">Good To Go</option>
              <option value="Sent To Art">Sent To Art</option>
              <!-- <option value="Sent To AWS for Color/Import">Sent To AWS for Color/Import</option> -->
              <option value="Sent To WE">Sent To WE</option>
              <option value="Hold/Sent For Approval">Hold/Sent For Approval</option>
              <option value="Events-Check Shipping">Events-Check Shipping</option>
            </select>
            <spacer />
          </div>
          <div class="col-sm-12 text-center float-left pb-2">
            <!-- <CButton color="info" style="width:100%;" size="sm" @click="reorder()">Re-Order (Whole PO)</CButton> -->
            <CButton color="secondary" v-if="pdf.as400_status !== 'Waiting On Customer'" style="width:100%;margin-top:10px;" size="sm" @click="clone('clone')">Clone {{pdf.as400_log_number}}</CButton>
            <CButton color="secondary" v-if="pdf.as400_status !== 'Waiting On Customer'" style="width:100%;margin-top:10px;" size="sm" @click="clone('backorder')">Backorder {{pdf.as400_log_number}}</CButton>
            <div style="width:100%;float:left;" v-if="form.status === 'Needs Ship To'">
              <CButton size="sm" style="width:100%;float:left;margin-top:10px;" color="success" @click="shipToModal = true">Add Ship To</CButton>
            </div>
            <div style="width:100%;float:left;" v-else>
              <CButton size="sm" style="width:100%;float:left;margin-top:10px;" color="success" v-if="pdf.as400_status === 'Waiting On Customer'" @click="approveOrder()">Approve</CButton>
              <CButton size="sm" style="width:100%;float:left;margin-top:10px;" color="warning" v-if="pdf.as400_status === 'Waiting On Customer'" @click="editSave()">Clone & Cancel</CButton>
              <CButton size="sm" style="width:100%;float:left;margin-top:10px;" color="danger" v-if="pdf.as400_status === 'Waiting On Customer'" @click="cancelOrder()">Cancel</CButton>
            </div>
          </div>
          <spacer />
          <div class="col-sm-12 text-center float-left pb-2">
            <CButton size="sm" style="width:100%;float:left;" color="dark" @click="configureEmails()">Resend Email {{pdf.as400_log_number}}</CButton>
          </div>
          <div class="col-sm-12 text-center float-left pb-2" v-if="$store.state.user.user_type === 'csr'">
            <CButton size="sm" style="width:100%;float:left;" color="success" @click="submitToNetSuite('re-submit')">Re-Submit To NetSuite</CButton>
          </div>
          <div class="col-sm-12 text-center float-left pb-2" v-if="$store.state.user.user_type === 'csr'">
            <CButton size="sm" style="width:100%;float:left;" color="success" @click="submitToNetSuite('generate')">Generate Pdf (only if error)</CButton>
          </div>
          <spacer />
          <div class="col-sm-12 text-center float-left pb-2" v-if="$store.state.user.user_type === 'csr'">
            <h5 style="width:100%;float:left;text-align:center;font-size:12px;">Expected Margin</h5>
            <input type="text" class="form-control" v-model="pdf.expected_margin" @change="actionsChanged('expected_margin')" />
          </div>
          <spacer />
          <div class="col-sm-12 text-center float-left pb-2" v-if="pdf.promotion_order && pdf.promotion_order.redeemed === 0">
            <h5 style="width:100%;float:left;text-align:center;font-size:12px;">Submit Promotion Order</h5>
            <CButton size="sm" style="width:100%;float:left;" color="success" @click="goToPromotion()">Go To Promotion</CButton>
          </div>
          <!-- <div class="col-sm-12 col-md-6 text-center float-left">
            <CButton color="success" size="sm" style="width:100%;" @click="createComponent()">Create Component</CButton><br /><br />
          </div>
          Generate Flow Requests Here As Well -->
        </CCardBody>
      </CCollapse>
    </CCard>

    <files-viewer :pdf="pdf"></files-viewer>
    
    <big-loader v-if="loading"></big-loader>

    <CModal
        title="Email"
        size="sm"
        :show.sync="emailModal"
      >
      <div style="width:100%;float:left;" v-if="emailsArray">
        <h5 style="width:100%;float:left;text-align: center;font-size:12px;">Select email(s) to send the order to.</h5>
        <table class="table">
          <thead>
            <tr>
              <th>
                <input type="checkbox" :checked="checkAll()" @click="selectAll()" />
              </th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in emailsArray">
              <td>
                <input type="checkbox" :checked="checkSelected(val)" @click="changeSelected(val)"  />
              </td>
              <td>{{val}}</td>
            </tr>
          </tbody>
        </table>
        <spacer />
        <div style="width:100%;float:left;">
          <h5 style="font-size: 12px;width:100%;float:left;text-align:center;">Enter extra email(s) that you would like to send the order copy to (if needed).</h5>
          <h5 style="font-size: 12px;color:red;width:100%;float:left;text-align:center;">Please separate emails with a comma if you are wanting to send to multiple.</h5>

          <div style="width:100%;float:left;">
            <input placeholder="Enter emails here...." type="text" class="form-control" v-model="extra_emails" />
          </div>
        </div>

        <spacer />

        <textarea class="form-control" placeholder="Enter text that you would like to be sent with the email (if you would like)" v-model="email_text" rows="4"></textarea>
      </div>
      <template #footer>
        <CButton @click="emailModal = false" color="danger">Cancel</CButton>
        <CButton color="success" @click="sendEmail()" :disabled="emailLoading">Send</CButton>
        <small-loader v-if="emailLoading"></small-loader>
      </template>
    </CModal>

    <CModal
        title="Ship To Modal"
        size="sm"
        :show.sync="shipToModal"
      >
      <div style="width:100%;float:left;" v-if="shipToModal">
        <h5 style="width:100%;float:left;text-align:center;font-size:14px;color:red;">Make sure the values are exactly like they are in the AS400.</h5>
        <CInput
          type="text"
          label="Ship To Number"
          v-model="form.ship_to_info.ship_to_number"
          />
        <CInput
          type="text"
          label="Ship Name"
          v-model="form.ship_to_info.ship_name"
          />
        <CInput
          type="text"
          label="Contact Name"
          v-model="form.ship_to_info.contact_name"
          />
        <CInput
          type="text"
          label="Address"
          v-model="form.ship_to_info.address_1"
          />
        <CInput
          type="text"
          label="City"
          v-model="form.ship_to_info.city"
          />
        <div>
          <label>State</label>
          <v-select v-model="form.ship_to_info.state" :options="states"></v-select>
        </div>
        <CInput
          style="margin-top:15px;"
          type="text"
          label="Zip Code"
          v-model="form.ship_to_info.zip_code"
          />
        <CInput
          type="text"
          label="Email"
          v-model="form.ship_to_info.email"
          />
        <CInput
          type="text"
          label="Phone #"
          v-model="form.ship_to_info.phone"
          />
      </div>
      <template #footer>
        <CButton @click="shipToModal = false" color="danger">Cancel</CButton>
        <CButton color="success" v-if="configureShipTo()" @click="submitShipTo()">Submit Ship To</CButton>
        <span v-else>Submit button will appear when filled in</span>
      </template>
    </CModal>
  </div>
</template>
<script>
import FilesViewer from './files_viewer'
var methods = {}

methods.configureShipTo = function () {
  var arr = ['ship_name', 'ship_to_number', 'address_1', 'city', 'state', 'zip_code', 'email', 'phone']
  var that = this
  var b = true
  arr.forEach(function (val) {
    if (that.form.ship_to_info[val] === '') {
      b = false
    }
  })
  return b
}

methods.sendEmail = function () {
  this.emailLoading = true
  const postData = {
    emails: this.emails_selected,
    text: this.email_text,
    order_group_id: this.pdf.order_group_id,
    extra_emails: this.extra_emails
  }
  axios.post(this.$apiAdress + '/api/orders/resendEmail?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    var str = ''
    this.emails_selected.forEach(function (e) {
      str += e + ','
    })
    str = str.substr(0, str.length - 1)
    if (this.extra_emails) {
      str = str + ',' + this.extra_emails
    }
    this.emailModal = false
    this.emails_selected = []
    this.email_text = ''
    this.extra_emails = ''
    this.emailLoading = false
    window.Swal.fire({
      type: 'success',
      title: 'Success!',
      timer: '4000',
      text: 'The email has been sent to ' + str
    })
  })
}

methods.submitToNetSuite = function (type) {
  const postData = {
    order_group_id: this.pdf.order_group_id,
    type: type
  }
  axios.post(this.$apiAdress + '/api/orders/submitToNetSuite?token=' + localStorage.getItem('api_token'), postData).then(response => {
    window.Swal.fire({
      type: 'success',
      title: 'Success!',
      timer: '2000',
      text: 'This order has been submitted to NetSuite.'
    })
  })
}

methods.checkSelected = function (val) {
  if (this.emails_selected.indexOf(val) > -1) {
    return 1
  } else {
    return 0
  }
}

methods.goToPromotion = function () {
  this.$router.push('/create_order/' + this.pdf.promotion_order.token + '/promotion')
}

methods.checkAll = function () {
  if (this.emails_selected.length) {
    return 1
  } else {
    return 0
  }
}

methods.changeSelected = function (val) {
  if (this.emails_selected.indexOf(val) > -1) {
    this.emails_selected.splice(this.emails_selected.indexOf(val), 1)
  } else {
    this.emails_selected.push(val)
  }
}

methods.selectAll = function () {
  if (this.emails_selected.length) {
    this.emails_selected = []
  } else {
    // this.addAllEmails()
    var that = this
    this.emailsArray.forEach(function (v) {
      that.emails_selected.push(v)
    })
  }
}

methods.addAllEmails = function () {
  var arr = []
  if (this.form.customer_info.email) {
    arr.push(this.form.customer_info.email)
  }
  if (this.form.ship_to_info.email) {
    arr.push(this.form.ship_to_info.email)
  }

  arr.push(this.form.rep.email)
  this.emailsArray = arr
}

methods.configureEmails = function () {
  this.addAllEmails()
  this.emailModal = true
}

methods.submitShipTo = function () {
  const postData = {
    form: this.form
  }
  axios.post(this.$apiAdress + '/api/orders/submitShipToFromOrder?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.form.status = 'Needs Entered'
    var that = this
    response.data.forEach(function (val) {
      if (parseInt(val.order_group_id) === parseInt(that.pdf.order_group_id)) {
        that.pdf.as400_status = val.as400_status
      }
    })
    this.shipToModal = false
    window.Swal.fire({
      type: 'success',
      title: 'Success!',
      text: 'You have submitted the ship to for this order.'
    })
  })
}

methods.approveOrder = function () {
  this.$emit('approve')
}

methods.cancelOrder = function () {
  window.Swal.fire({
    title: 'Are you sure?',
    text: 'Doing this will cancel the current Log #' + this.pdf.as400_log_number + '.',
    showCancelButton: true,
    confirmButtonText: 'Yes, Cancel!',
    cancelButtonText: 'Nevermind'
  }).then((result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      this.loading = true
      // var arr = []
      // this.editFiles.forEach(function (f) {
      //   arr.push(f.id)
      // })
      axios.post(this.$apiAdress + '/api/orders/cancelOrderGroup?token=' + localStorage.getItem('api_token'), this.pdf).then(response => {
        console.log(response)
        this.pdf.as400_status = 'Canceled'
        this.pdf.as400_status_code = 8
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    }
  })
}

methods.actionsChanged = function (type) {
  const postData = {
    form: this.pdf,
    type: type
  }

  axios.post(this.$apiAdress + '/api/orders/orderActionsChanged?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
  })
}

methods.changeCsrStatus = function () {
  const postData = {
    form: this.pdf
  }
  axios.post(this.$apiAdress + '/api/orders/changeCsrStatus?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
  })
}

methods.reorder = function () {
  this.$router.push('/create_order/' + this.order_id)
}

methods.clone = function (type) {
  this.$router.push('/create_order/' + this.pdf.order_group_id +'/' + type)
}

methods.changeCSR = function () {
  const postData = {
    order_group_id: this.pdf.order_group_id,
    user_id: this.pdf.csr_assigned_id
  }
  axios.post(this.$apiAdress + '/api/orders/changeRep?token=' + localStorage.getItem('api_token'), postData).then(response => {
    if (response.data.success) {
      // Find the new rep name from the users list
      const newRep = this.users.find(user => user.id === this.pdf.csr_status);
      if (newRep) {
        this.form.user.name = newRep.name;
      }

      window.Swal.fire({
        type: 'success',
        title: 'Success!',
        text: 'The CSR has been changed successfully.'
      });
    } else {
      window.Swal.fire({
        type: 'error',
        title: 'Error!',
        text: 'There was an error changing the representative.'
      });
    }
  }).catch(error => {
    console.log(error);
    window.Swal.fire({
      type: 'error',
      title: 'Error!',
      text: 'There was an error changing the representative.'
    });
  });
}



methods.editSave = function () {
    // this.$router.push('/create_order/' + this.pdf.order_group_id +'/clone')
    window.Swal.fire({
        title: 'Are you sure?',
        text: 'Doing this will cancel the current Log #' + this.pdf.as400_log_number + ' and clone it to a new order for you to edit/resubmit.',
        showCancelButton: true,
        confirmButtonText: 'Yes, Cancel & Clone!',
        cancelButtonText: 'Nevermind'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.loading = true
          // var arr = []
          // this.editFiles.forEach(function (f) {
          //   arr.push(f.id)
          // })
          const postData = {
            order_group_id: this.pdf.order_group_id
          }
          axios.post(this.$apiAdress + '/api/orders/cancelCloneOrderGroup?token=' + localStorage.getItem('api_token'), postData).then(response => {
            this.$router.push('/create_order/' + this.pdf.order_group_id +'/clone_cancel')
          })
        }
      })
}

export default {
  // ===Component name
  name: "OrderActions",
  // ===Props passed to component
  props: ['form', 'order_id', 'pdf', 'users'],
  // ===Components used by this component
  components: {
    FilesViewer
  },
  // ====component Data properties
  data(){
      return{
        involvedModal: true,
        loading: false,
        shipToModal: false,
        emailModal: false,
        emailsArray: null,
        emailLoading: false,
        email_text: '',
        extra_emails: '',
        emails_selected: [],
        states: ['AL','AK','AZ','AR','AS','CA','CO','CT','DE','DC','FL','GA','GU','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','CM','OH','OK','OR','PA','PR','RI','SC','SD','TN','TX','TT','UT','VT','VA','VI','WA','WV','WI','WY'],
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    // this.configureImages()
    // this.$refs.myVueDropzone..removeAllFiles() = false
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
